<template>
  <div class="Index" >
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="安装" >
        <span slot="label"><i class="el-icon-s-home"></i>上门安装</span>
        <div class="title-tip">该服务目前仅支持门锁，如有其它产品需求请前往自助留言反馈，谢谢！</div>
        <InstallInfo ref="InstallInfo">&nbsp;</InstallInfo>
      </el-tab-pane>
      <el-tab-pane label="维修">
        <span slot="label"><i class="el-icon-phone"></i>上门维修</span>
        <div class="title-tip">该服务目前仅支持门锁，如有其它产品需求请前往自助留言反馈，谢谢！</div>
        <MaintainInfo ref="MaintainInfo">&nbsp;</MaintainInfo>
      </el-tab-pane>
      <el-tab-pane label="我的订单">
        <span slot="label"><i class="el-icon-user-solid"></i>进度查询</span>
        <MyOrder ref="MyOrder">&nbsp;</MyOrder>
      </el-tab-pane>
      <el-tab-pane label="在线留言">
        <span slot="label" @click="onlineMsg">自助留言</span>
      </el-tab-pane>
    </el-tabs>
<!--    <FloatBall :text="'在线留言'"></FloatBall>-->
<!--    <FloatButton></FloatButton>-->
  </div>
</template>

<script>
    import InstallInfo from "../../components/InstallInfo"
    import MaintainInfo from "../../components/MaintainInfo"
    import MyOrder from "../../components/MyOrder"
    import wx from "weixin-js-sdk";
    // import FloatBall from '@/components/FloatBall'
    // import FloatButton from '@/components/FloatButton'

    // import marqueeLeft from '@/components/marquee'

    export default {
        name: "Index",
        components:{
            InstallInfo,
            MaintainInfo,
            MyOrder
            // ,FloatBall
            // ,FloatButton
            // ,marqueeLeft
        },
        data() {
            return{
                fastcode: '',
                fastopenid: '',
                fastunionid: '',
                // 我的已有产品
                myProducts: [],

                // 显示的产品型号
                productNameArr: [
                    'X1','X3'
                    // ,
                    // 'G27',
                    // 'MX-B048047A-BS','MX-B048045C-BS','MX-B048046C-BD','MX-C048A-BS','MX-B048045A-BS',
                    // 'MX-B055046A-BS','MX-B048045B-BS','MX-B055046B-BS','MX-B048046B-BD','MX-C050055A-BE',
                    // 'MX-C130092A-BS','MX-C150093A-BS','MX-C150093A-BD','MX-C130086A-BS','MX-C130095B-BE',
                    // 'MX-C150A-BS','MX-D082065A-BS','MX-D128110A-BS','MX-A012023A-AS','MX-A018030A-AS',
                    // 'MX-A024035D-BS24W','MX-A024A-AS','MX-A024C-AS','MX-A024D-AS','MX-A018030B-AS',
                    // 'MX-A024035B-AS','MX-A018030C-AS','MX-B024035B-AS','MX-B024035A-AS','MX-B12440-A',
                    // 'MX-B12440-B','MF-A136A-BS','MF-B069A-BS',
                    // ,'MY-B2K4060C-AD','MY-A2K4060A-AD','MY-B2K4060D-BD','MY-A2K4060B-BD'
                ],
                // 智能锁系列包含的产品型号
                Series1: [
                    'X1','X3'
                ],
                // 智能开关系列包含的产品型号
                Series2: [
                    'G27'
                ],
                // 卧室灯系列包含的产品型号
                Series3: [
                    'MX-B048047A-BS','MX-B048045C-BS','MX-B048046C-BD','MX-C048A-BS','MX-B048045A-BS',
                    'MX-B055046A-BS','MX-B048045B-BS','MX-B055046B-BS','MX-B048046B-BD','MX-C050055A-BE'
                ],
                // 客厅灯系列包含的产品型号
                Series4: [
                    'MX-C130092A-BS','MX-C150093A-BS','MX-C150093A-BD','MX-C130086A-BS','MX-C130095B-BE',
                    'MX-C150A-BS','MX-D082065A-BS'
                ],
                // 吸顶灯系列包含的产品型号
                Series5: [
                    'MX-D128110A-BS','MX-A012023A-AS','MX-A018030A-AS','MX-A024035D-BS24W','MX-A024A-AS',
                    'MX-A024C-AS','MX-A024D-AS','MX-A018030B-AS','MX-A024035B-AS','MX-A018030C-AS',
                    'MX-B024035B-AS','MX-B024035A-AS','MX-B12440-A','MX-B12440-B'
                ],
                // 吊灯系列包含的产品型号
                Series6: [
                    'MF-A136A-BS','MF-B069A-BS'
                ],
                // 浴霸系列包含的产品型号
                Series7: [
                    'MY-B2K4060C-AD','MY-A2K4060A-AD','MY-B2K4060D-BD','MY-A2K4060B-BD'
                ]

            }
        },
        created() {
            const code = this.$route.query.code;

            const appid = window.localStorage.getItem("fastappid");
            // axios请求token
            // this.$axios.get('/apis/Weixin/GetUserInfo?code=061HLe1C0knJvj2sgX0C0ftw1C0HLe1L&appId=wxa9f5dd8a96e17e12')
            // this.$axios.get('http://bullchat.vitters.cn/Weixin/GetUserInfo?code='+code+'&appId='+appid)
            this.$axios.get('http://bcss.gongniu.cn/wrc/Weixin/GetUserInfo?code='+code+'&appId='+appid)
                .then((response) => {
                    // 将openid和unionid存入localStorage
                    window.localStorage.setItem("fastopenid",response.data.result.openid);
                    this.fastunionid = response.data.result.unionid;
                    window.localStorage.setItem("fastunionid",this.fastunionid);
                })
                .catch((error) => {
                    // console.log(error);//异常
                    this.$confirm('获取用户信息失败，请重试'+error, '', {
                        confirmButtonText: '确定',
                        showCancelButton: false,
                        type: 'error',
                        showClose: false,
                        customClass: 'message-logout'
                    }).then(() => {
                        wx.closeWindow();
                    }).catch(() => {
                        // DO NOTHING
                    });
                });


            // const openid = window.localStorage.getItem('fastopenid');
            // const unionid = window.localStorage.getItem('fastunionid');
            // if(!code) {
            //     if(!openid || !unionid) {
            //         this.$router.push({
            //             name:"Auth",
            //         })
            //     }else{
            //         this.fastopenid = openid;
            //         this.fastunionid = unionid;
            //         // this.searchMyProduct();
            //     }
            // }else{
            //     if(!openid || !unionid) {
            //         // 若有code且没有用户信息，则为微信回调，调接口请求用户数据
            //         const appid = window.localStorage.getItem("fastappid");
            //         // axios请求token
            //         // this.$axios.get('/apis/Weixin/GetUserInfo?code=061HLe1C0knJvj2sgX0C0ftw1C0HLe1L&appId=wxa9f5dd8a96e17e12')
            //         // this.$axios.get('http://bullchat.vitters.cn/Weixin/GetUserInfo?code='+code+'&appId='+appid)
            //         this.$axios.get('http://bcss.gongniu.cn/wrc/Weixin/GetUserInfo?code='+code+'&appId='+appid)
            //             .then((response) => {
            //                 // 将openid和unionid存入localStorage
            //                 window.localStorage.setItem("fastopenid",response.data.result.openid);
            //                 this.fastunionid = response.data.result.unionid;
            //                 window.localStorage.setItem("fastunionid",this.fastunionid);
            //             })
            //             .catch((error) => {
            //                 // console.log(error);//异常
            //                 this.$confirm('获取用户信息失败，请重试'+error, '', {
            //                     confirmButtonText: '确定',
            //                     showCancelButton: false,
            //                     type: 'error',
            //                     showClose: false,
            //                     customClass: 'message-logout'
            //                 }).then(() => {
            //                     wx.closeWindow();
            //                 }).catch(() => {
            //                     // DO NOTHING
            //                 });
            //             });
            //     }else{
            //         this.fastopenid = openid;
            //         this.fastunionid = unionid;
            //         // this.searchMyProduct();
            //     }
            // }
        },
        // mounted() {
        //     this.$refs.InstallInfo.setMyProducts(this.myProducts);
        //     this.$refs.MaintainInfo.setMyProducts(this.myProducts);
        // },
        watch: {
            // 监听fastunionid：当有fastunionid时，根据unionid查询产品
            fastunionid: {
                handler(){
                    this.searchMyProduct();
                },
                deep: true
            }
        },
        methods: {
            onlineMsg(){
                // console.log("在线留言")
                window.location.href = 'https://bull.custhelp.com/app/ask';
            },
            searchMyProduct(){
                console.log("indexpage: 根据查询我的产品, unionid: " + this.fastunionid);
                this.$axios.get(this.$baseURL + `/rnow/unionidassets/` + this.fastunionid)
                    .then(data=> {
                        if(data.data==null || data.data=="" || data.data=='undefined'){
                            // 该unionid下无联系人资产
                            console.log("IndexPage myProducts: 该unionid下无资产");
                        }else {
                            for(let j = 0,len=data.data.length; j < len; j++) {
                                if(this.productNameArr.indexOf(data.data[j][3])<0){
                                    continue;
                                }
                                let p = {
                                    assetsId:data.data[j][0],
                                    productId:data.data[j][1],
                                    type:data.data[j][2],
                                    series:this.confirmProductSeriesByModel(data.data[j][3]),
                                    model:data.data[j][3],
                                    snCode:data.data[j][4]};
                                this.myProducts.push(p);
                            }
                            console.log("IndexPage myProducts: ",this.myProducts);
                        }
                        this.$refs.InstallInfo.setMyProducts(this.myProducts);
                        this.$refs.MaintainInfo.setMyProducts(this.myProducts);
                    })
                    .catch(error=> {
                        console.log(error);
                    });
            },
            confirmProductSeriesByModel(model){
                if(this.Series1.indexOf(model)>=0){
                    return "智能锁"
                }else if(this.Series2.indexOf(model)>=0){
                    return "智能开关"
                }else if(this.Series3.indexOf(model)>=0){
                    return "卧室灯"
                }else if(this.Series4.indexOf(model)>=0){
                    return "客厅灯"
                }else if(this.Series5.indexOf(model)>=0){
                    return "吸顶灯"
                }else if(this.Series6.indexOf(model)>=0){
                    return "吊灯"
                }else if(this.Series7.indexOf(model)>=0){
                    return "浴霸"
                }
            }
        }
    };
</script>

<style scoped>
  /*.Index {*/
  /*  height: 100%;*/
  /*}*/
  /*.Index > .el-tabs{*/
  /*  height: 100%;*/
  /*  position: relative;*/
  /*  overflow: hidden;*/
  /*}*/
  .title-tip {
    font-size: 12px;
    color: #c63e3e;
    margin: 0px 0px 10px 0px;
  }
</style>
<style>
  .el-tabs__item {
    padding : 0 10px!important;
  }
  /*.Index > .el-tabs > .el-tabs__content {*/
  /*  !*height: 100%;*!*/
  /*  !*display: table-cell;*!*/
  /*  overflow: scroll!important;*/
  /*  position: absolute!important;*/
  /*  top: 40px;*/
  /*  bottom: 0px;*/
  /*  left: 0px;*/
  /*  right: 0px;*/
  /*}*/
</style>
